import React from "react";
import { getImageBaseUrl } from "../services/s3-utils";

function Empty({
  title,
  heading,
  noPadding,
  buttonText,
  className,
  onClick,
  imageSrc,
  imageContainer,
  imageClassName,
  buttonClassName
}) {
  return (
    <div
      className={`w-full flex flex-col items-center ${
        noPadding ? "py-10" : "sm:py-[187px] py-20"
      } ${className}`}
    >
      <div className={`flex items-center justify-center ${imageContainer}`}>
        <img
          className={`w-20 h-20 ${imageClassName}`}
          src={imageSrc || `${getImageBaseUrl}/assets/empty-state.svg`}
          alt=""
        />
      </div>

      {heading}
      <p className="text-base leading-[29px] font-medium text-tint mt-6 mb-0 text-center">
        {title}
      </p>
      {buttonText ? (
        <button
          className={`py-3 px-6 text-white bg-pri mt-6 rounded-md font-semibold w-full ${buttonClassName}`}
          onClick={onClick}
        >
          <p className="p-sm mb-0">{buttonText}</p>
        </button>
      ) : (
        ""
      )}
    </div>
  );
}

export default Empty;
